






















import Vue from 'vue';

export default Vue.extend({
    props: {
        dark: [Boolean],
        coloured: [Boolean],
        elevatedBg: [Boolean],
        bgHeight: {
            type: String,
            default: '200px',
        },
    },
});
